/* Lookbook parallax: replicate the live skrollr inner (data-bottom-top "top:-N%" -> data-top-bottom "top:0%"). */
(function () {
  'use strict';
  var bands = [];
  function collect() {
    bands = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]')).map(function (band) {
      var inner = band.querySelector('[data-parallax-inner]');
      var depth = inner ? Number(inner.dataset.depth) || 200 : 200;
      return { band: band, inner: inner, depth: depth, off: depth - 100, last: '' };
    }).filter(function (b) { return b.inner; });
  }
  function update() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    bands.forEach(function (b) {
      var r = b.band.getBoundingClientRect();
      /* live (skrollr) spreads the travel over the viewport PLUS the inner height, not the band height */
      var total = vh + r.height * (b.depth / 100);
      var p = (vh - r.top) / total;   /* 0 = band top at viewport bottom, 1 = band bottom at viewport top */
      if (p < 0) p = 0; else if (p > 1) p = 1;
      var v = (-(b.off) * (1 - p)) + '%';
      if (v !== b.last) { b.last = v; b.inner.style.top = v; }
    });
  }
  function loop() { update(); requestAnimationFrame(loop); }
  function init() { collect(); update(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  document.addEventListener('shopify:section:load', init);
  /* skrollr re-renders on a rAF loop, so the crop is right even after a programmatic scroll */
  requestAnimationFrame(loop);
})();

/* Lookbook full-width slider: the live goya .et-banner-slider is slick with fade:false, so it is a
   horizontal track move of data-speed ms (cssEase 'ease'), then a data-dwell pause before the next
   (slick restarts its autoplay timer after the slide lands, so the cycle is speed + dwell).
   Infinite forward wrap via one trailing clone, pause on hover only where live sets data-pause. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.zkReady) return;
    var track = root.querySelector('[data-zk-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var n = slides.length;
    if (n < 2) { root.dataset.zkReady = '1'; return; }
    root.dataset.zkReady = '1';
    var speed = Number(root.dataset.speed) || 600;
    var dwell = Number(root.dataset.dwell) || 2000;
    var pause = root.dataset.pause === '1';
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-zk-dot]'));
    var clone = slides[0].cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('data-zk-slide');
    track.appendChild(clone);
    var i = 0, timer = null, settle = null;
    function place(idx, anim) {
      track.style.transition = anim ? 'transform ' + speed + 'ms ease' : 'none';
      track.style.transform = 'translate3d(' + (-idx * 100) + '%,0,0)';
    }
    function mark() {
      var real = i % n;
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', String(k !== real)); });
      dots.forEach(function (d, k) {
        var on = k === real;
        d.setAttribute('aria-selected', String(on));
        if (d.parentElement) { d.parentElement.classList.toggle('is-active', on); d.parentElement.classList.toggle('slick-active', on); }
      });
    }
    function go(next) {
      clearTimeout(timer); clearTimeout(settle);
      i = next; place(i, true); mark();
      settle = setTimeout(function () {
        if (i === n) { i = 0; place(0, false); }
        schedule();
      }, speed);
    }
    function schedule() { clearTimeout(timer); timer = setTimeout(function () { go(i + 1); }, dwell); }
    function stop() { clearTimeout(timer); timer = null; }
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var t = Number(d.dataset.zkDot) || 0;
        if (t === i % n) return;
        go(t);
      });
    });
    if (pause) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', function () { if (!timer) schedule(); });
    }
    place(0, false); mark();
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) schedule();
  }
  function boot() { document.querySelectorAll('[data-zk-slider]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
